module.exports = __webpack_public_path__ + "img/hourglass.fc106a5c.svg";